import React from "react";
import PageHero from "../components/PageHero";

const certs = [
  {
    img: "https://kikicentre.com/wp-content/uploads/2022/03/certificate-1.jpg",
    title: "Kiki Centre for Technology",
    desc: "All students, depending on their performance in a course, receive a Certificate of Participation or Certificate of Completion through Kiki Centre for Technology.",
  },
  {
    img: "https://kikicentre.com/wp-content/uploads/2022/03/CGSC-Certificate.jpg",
    title: "Capital Goods Skill Council (CGSC)",
    desc: "Anjali Foundation (under the brand name Kiki Centre for Technology) is a certified Affiliated Training Centre of the Capital Goods Skill Council.",
  },
  {
    img: "https://kikicentre.com/wp-content/uploads/2022/03/index.jpg",
    title: "MSDE, Government of India",
    desc: "Certified through the Capital Goods Sector Skills Council (CGSC) and Automotive Skill Development Council (ASDC). For those courses, certificates are issued by the Ministry of Skill Development & Entrepreneurship, Government of India.",
  },
  {
    img: "https://kikicentre.com/wp-content/uploads/2022/03/tuv-1.jpg",
    title: "ISO 9000 (TÜV Nord)",
    desc: "Anjali Foundation (under the brand name Kiki Centre for Technology) is ISO 9000 compliant and certified for its systems through TÜV Nord.",
  },
  {
    img: "https://kikicentre.com/wp-content/uploads/2022/03/germay.jpg",
    title: "German Chamber of Skilled Crafts, Koblenz",
    desc: "Assessment and certification for the 3.5-year courses are through the German Chamber of Skilled Crafts (HWK), Koblenz, Germany.",
  },
];

export default function CertificationsPage() {
  return (
    <div data-testid="certifications-page">
      <PageHero
        path="certifications.hero"
        kicker="Certifications"
        title="Credentials that open doors"
        subtitle="Our certifications are recognized in India and globally — from the Government of India to the German Chamber of Skilled Crafts in Koblenz."
      />
      <section className="py-16">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 gap-6">
          {certs.map((c, i) => (
            <div
              key={c.title}
              className="bg-white rounded-2xl p-7 border border-slate-100 shadow-sm tilt-card animate-fade-up flex gap-5"
              style={{ animationDelay: `${i * 0.07}s` }}
              data-testid={`cert-${i}`}
            >
              <div className="shrink-0 h-24 w-24 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center overflow-hidden p-2">
                <img src={c.img} alt={c.title} className="max-h-full max-w-full object-contain" />
              </div>
              <div>
                <h3 className="font-bold text-[#0B2A6B] text-lg mb-2">{c.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
